import React from 'react';
import { VersionedObjectDiff } from '@clearcover/core-app-types';
import { ChangeCardAndDetails } from '../PolicyChangeCard';
import {
  PolicyChangeCard,
  changeTypes,
} from '../PolicyChangeCard/PolicyChangeCard';
import { DisplayInsurableItemRelationship } from '@clearcover/core-app-types/dist/endpoints/getPolicy/displayInsurableItemRelationship';
import { InsurableItemRelationshipChangeDetails } from './InsurableItemRelationshipChangeDetails';
import { capitalizeFirstLetter } from 'Policies/utils/helpers';

export const toInsurableItemRelationshipChangeCardAndDetails = (
  diff: VersionedObjectDiff<DisplayInsurableItemRelationship>
): ChangeCardAndDetails => {
  const displayType = diff.type;
  const displayRelationship = capitalizeFirstLetter(
    diff.new?.relationship ?? ''
  );
  const title = `Insurable Item Relationship ${changeTypes[displayType]}`;
  const value = 'Relationship ' + displayRelationship;

  return {
    card: ({ 'data-testid': dataTestId, selected, onClick }) => (
      <PolicyChangeCard
        data-testid={dataTestId}
        title={title}
        onClick={onClick}
        selected={selected}
        type="insurableItemRelationship"
        action={displayType}
        value={value}
      />
    ),
    details: () => <InsurableItemRelationshipChangeDetails diff={diff} />,
    metadata: {
      type: 'insurableItemRelationship',
      action: displayType,
      title,
      value,
    },
  };
};
